import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
import LogoPng from "../../assets/svg/Logo.png"; // use your PNG logo here

export default function Contact() {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <Wrapper>
      <div className="offWhiteBg">
        <div className="container">
          <FooterGrid>
            {/* Company Info */}
            <FooterCol>
              <LogoWrapper>
                <img src={LogoPng} alt="Sama Al Falah Logo" className="logo" />
                <h1
                  className="extraBold"
                  style={{ marginLeft: "15px", color: "#000", fontSize: "20px" }}
                >
                  Sama Al Falah
                </h1>
              </LogoWrapper>
              <p
                style={{
                  marginTop: "15px",
                  color: "#555",
                  fontSize: "15px",
                  lineHeight: "1.6",
                }}
              >
                Sama Al Falah Computer TR LLC <br />
                Warehouse Store in Sharjah, UAE
              </p>
              <p style={{ color: "#555", fontSize: "14px" }}>
                © {getCurrentYear()} - All Rights Reserved
              </p>
            </FooterCol>

            {/* Contact Info */}
            <FooterCol>
              <h3 style={{ color: "#000", fontSize: "18px", marginBottom: "15px" }}>
                Contact Us
              </h3>
              <p style={{ color: "#555", fontSize: "15px", lineHeight: "1.6" }}>
                📍 J & P BUILDING - WAREHOUSE NO. 46 <br />
                Industrial Area 5 - Sharjah, UAE
              </p>
              <p style={{ fontSize: "15px", margin: "8px 0" }}>
                📞{" "}
                <a href="tel:+97167044236" style={{ color: "#7620ff", fontWeight: "600" }}>
                  +971 6 704 4236
                </a>
              </p>
              <p style={{ fontSize: "15px" }}>
                ✉️{" "}
                <a
                  href="mailto:contact@samaalfalah.com"
                  style={{ color: "#7620ff", fontWeight: "600" }}
                >
                  contact@samaalfalah.com
                </a>
              </p>
            </FooterCol>

            {/* Google Map */}
            <FooterCol>
              <h3 style={{ color: "#000", fontSize: "18px", marginBottom: "15px" }}>
                Find Us
              </h3>
              <MapWrapper>
                <iframe
                  title="Sama Al Falah Computer TR LLC"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.653507003671!2d55.40901317501847!3d25.327289377863083!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f595fbd2debc3%3A0x928c2ace213efa88!2sSama%20Al%20Falah%20Computer%20TR%20LLC!5e0!3m2!1sen!2sae!4v1726505000000!5m2!1sen!2sae"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </MapWrapper>
            </FooterCol>
          </FooterGrid>

          {/* Bottom Bar */}
          <BottomBar className="flexSpaceCenter">
          <Link
            to="home"
            smooth={true}
            offset={-80}
          >
            Back to top ↑
          </Link>

          </BottomBar>
        </div>
      </div>
    </Wrapper>
  );
}

/* =================== STYLES =================== */
const Wrapper = styled.div`
  width: 100%;
  margin-top: 60px;
  background: #f9f9f9; /* Off-white */
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  padding: 60px 0;

  @media (max-width: 860px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .logo {
    width: 60px;
    height: auto;
  }

  @media (max-width: 860px) {
    justify-content: center;
  }
`;

const FooterCol = styled.div`
  a {
    text-decoration: none;
    transition: 0.3s;
  }
  a:hover {
    color: #580cd2;
  }
`;

const MapWrapper = styled.div`
  margin-top: 15px;
  iframe {
    width: 100%;
    height: 220px;
    border: 0;
    border-radius: 10px;
  }
`;

const BottomBar = styled.div`
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 20px 0;
  margin-top: 20px;

  @media (max-width: 550px) {
    flex-direction: column;
    gap: 10px;
  }
`;
